import {
  addMonths, endOfMonth, format, parse, startOfMonth, subMonths,
} from 'date-fns';
import BookingSlots from '../api/booking-slots';
import Users from '../api/users';

export default {
  namespaced: true,
  state: {
    slots: [],
    availability: null,
    interval: {
      start: format(new Date(), 'yyyy-MM-dd'),
      end: format(new Date(), 'yyyy-MM-dd'),
    },
  },
  getters: {
    slots(state) {
      return state.slots
        .filter(slot => slot.date >= state.interval.start && slot.date <= state.interval.end);
    },
    availableDays(state) {
      return state.slots
        .filter(slot => !slot.booked && slot.date >= format(new Date(), 'yyyy-MM-dd'))
        .map(slot => slot.date);
    },
    intervalStart(state) {
      return state.interval.start;
    }
  },
  actions: {
    setInterval({ commit }, interval) {
      commit('SET_INTERVAL', interval);
    },
    async getCoach({ commit }, coachId) {
      const { user } = await Users.getUser(coachId);
      commit('SET_AVAILABILITY', user.availability);

      return user;
    },
    async getCoachSlots({ commit }, { coach, start, end }) {
      const { slots } = await BookingSlots.getBookingSlots({
        coach_id: coach._id,
        start_time: start || startOfMonth(subMonths(new Date(), 1)),
        end_time: end || endOfMonth(addMonths(new Date(), 6)),
      });

      commit('SET_SLOTS', slots);

      return slots;
    },
    saveCoachSlots(context, { coach, slotData }) {
      const {
        specificDate,
        meetingDuration,
        startTime,
        endTime,
        breakTime,
      } = slotData;

      const start = startTime.split(':');
      const end = endTime.split(':');
      const startHour = parseInt(start[0], 10);
      const startMinute = parseInt(start[1], 10);
      const endHour = parseInt(end[0], 10);
      const duration = meetingDuration;
      const breakTimeDuration = breakTime;

      const nrFormat = nr => String(nr).padStart(2, '0');

      const computedSlotData = [];

      let startHourTemp = startHour;
      let startMinuteTemp = startMinute;
      while (startHourTemp < endHour) {
        const slotStart = `${nrFormat(startHourTemp)}:${nrFormat(startMinuteTemp)}`;
        startMinuteTemp += duration;

        let slotEnd = `${nrFormat(startHourTemp)}:${nrFormat(startMinuteTemp)}`;
        if (startMinuteTemp >= 60) {
          startHourTemp += 1;
          startMinuteTemp %= 60;

          slotEnd = `${nrFormat(startHourTemp)}:${nrFormat(startMinuteTemp)}`;
        }

        const startTimeZoned = parse(
          `${specificDate} ${slotStart}`,
          'yyyy-MM-dd HH:mm',
          new Date(),
        );

        const endTimeZoned = parse(
          `${specificDate} ${slotEnd}`,
          'yyyy-MM-dd HH:mm',
          new Date(),
        );

        computedSlotData.push({
          date: specificDate,
          duration,
          coach: coach._id,
          start_time: startTimeZoned,
          end_time: endTimeZoned,
        });

        startMinuteTemp += breakTimeDuration;

        if (startMinuteTemp >= 60) {
          startHourTemp += 1;
          startMinuteTemp %= 60;
        }
      }

      return BookingSlots.createBookingSlots(computedSlotData);
    },
    async bookSlot(context, params) {
      const { slotId, programId } = params;

      try {
        const { slot } = await BookingSlots.bookSlot(slotId, programId);

        return slot;
      } catch (error) {
        console.log('error', error.message);

        return null;
      }
    },
    async deleteBookingSlot(context, slotId) {
      try {
        await BookingSlots.deleteBookingSlot(slotId);
      } catch (error) {
        console.log('error', error);
      }
    },
    async deleteBookingSlots(context, slotIds) {
      try {
        await BookingSlots.deleteBookingSlots(slotIds);
      } catch (error) {
        console.log('error', error);
      }
    },
  },
  mutations: {
    SET_SLOTS(state, slots) {
      state.slots = slots.map(slot => ({
        ...slot,
        date: format(new Date(slot.start_time), 'yyyy-MM-dd'),
        start: format(new Date(slot.start_time), 'HH:mm'),
        end: format(new Date(slot.end_time), 'HH:mm'),
      }));
    },
    SET_AVAILABILITY(state, availability) {
      state.availability = availability;
    },
    SET_INTERVAL(state, interval) {
      state.interval = interval;
    },
    SET_PROGRAMS(state, programs) {
      state.programs = programs;
    },
  },
};
